import { ThemeConfig } from "antd";
import {
  accentColor,
  error,
  info,
  primaryColor,
  secondary,
  success,
  surface,
} from "./themeColors";

/** antd's token set, tuned to match the MUI theme so the two never disagree. */
export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: primaryColor,
    colorSuccess: success.main,
    colorWarning: accentColor,
    colorError: error.main,
    colorInfo: info.main,
    borderRadius: 8,
    fontFamily: "'Montserrat', sans-serif",
    fontSize: 13,
    colorBgContainer: surface.paper,
    colorBorder: surface.border,
    colorTextBase: secondary[500],
  },
  components: {
    Table: {
      headerBg: surface.subtle,
      headerColor: secondary[400],
      headerSortActiveBg: surface.page,
      borderColor: surface.borderSubtle,
      rowHoverBg: surface.subtle,
    },
    Card: { borderRadius: 12 },
    Select: { borderRadius: 8 },
    DatePicker: { borderRadius: 8 },
    Upload: { borderRadius: 8 },
    Modal: { borderRadius: 16 },
  },
};

export default antdTheme;
